var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-log" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "log-table",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", align: "center", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "action",
              label: "行为",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getActionTypeText(scope.row.action)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "mobile",
              label: "手机号",
              align: "center",
              width: "130",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "ext",
              label: "信息内容",
              align: "center",
              "min-width": "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "content-cell" }, [
                      _vm.parseExtContent(scope.row.ext)
                        ? _c(
                            "div",
                            { staticClass: "json-content" },
                            _vm._l(
                              _vm.parseExtContent(scope.row.ext),
                              function (value, key) {
                                return _c(
                                  "div",
                                  { key: key, staticClass: "json-item" },
                                  [
                                    _c("span", { staticClass: "json-key" }, [
                                      _vm._v(_vm._s(key) + ":"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "json-value" }, [
                                      _vm._v(_vm._s(value)),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _c("span", [_vm._v(_vm._s(scope.row.ext || "-"))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "addTime",
              label: "时间",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatTime(scope.row.addTime)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "adminName",
              label: "操作人",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.adminName || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-area" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }